import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import { Button, Typography } from '@material-ui/core';
import { contentElemenIdPrefix } from '../../../../constants';
import FormQuestion from '../../FormQuestion';
import { isEmpty } from '../../../../objectUtils';
import { InfoMessage } from '../../../../../common/components';

const styles = theme => ({
    root: {

    },
    results: {
        margin: theme.spacing(4, 0),
        boxShadow: theme.shadows[4],
        padding: theme.spacing(4, 2),
        background: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',

        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        },
    },
    scoreHeading: {
        flex: '1 1 auto',
        color: theme.youwell.colors.green,
    },
    resetButton: {
        marginLeft: theme.spacing(1),

        [theme.breakpoints.down('xs')]: {
            marginTop: theme.spacing(2),
        },
    },
});

// How to use a Quiz
// On the content-page:
// 1. Add a default element with all the questions
// 2. Add a default element with a Button-question. Text: "Show answers"
// 3. Add a "QuizResponse"-element with no content
// 4. Settings for element 3: elementId = id of element 1
// 5. Set the following conditional states:
//      Element 1: Default visible, hidden when "Show answers" is activated
//      Element 2: same as above (or keep always visible..)
//      Element 3: Default hidden, visible when "Show answers" is activated

class QuizResponse extends React.Component {
    resetQuiz = () => {
        const quizElement = this.getQuizElement();

        quizElement?.questions?.forEach((q) => {
            this.props.handleResponseUpdate(q)('choiceResponse', null);
        });

        if (window.scrollTo) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            document.documentElement.scrollTop = 0;
        }
    };

    getQuizElement = () => {
        const {
            element, taskId, getProgramItem,
        } = this.props;

        const elementSettings = element.settings || {};
        const quizTaskId = elementSettings.taskId || taskId;
        const quizTask = getProgramItem(quizTaskId);
        const elementId = elementSettings.elementId;

        if (!quizTask || !elementId) {
            return null;
        }

        return quizTask.contentElements?.find(e => e.id === Number(elementId));
    }

    render() {
        const {
            classes, element, taskId, translate, getSpecificTaskResponses, contentState,
        } = this.props;

        if (!element) {
            return null;
        }

        const elementSettings = element.settings || {};
        const quizTaskId = elementSettings.taskId || taskId;
        const quizElement = this.getQuizElement();

        if (!quizElement) {
            return <InfoMessage messageKey="noContent" />;
        }

        const taskResponses = getSpecificTaskResponses(quizTaskId);
        const questions = quizElement?.questions;

        const questionsWithAnswers = questions?.filter(d => d.answers?.length);

        if (!questionsWithAnswers?.length > 0) {
            return <InfoMessage messageKey="noContent" />;
        }

        if (!taskResponses || isEmpty(taskResponses)) {
            return <InfoMessage messageKey="task.pleaseAnswerQuiz" />;
        }

        const scoring = questionsWithAnswers.reduce((prev, curr) => (
            {
                score: prev.score + Number(taskResponses[curr.id]?.response?.choiceResponse?.reduce((pResp, cResp) => pResp + cResp.score || 0, 0) || 0),
                max: prev.max + Number(curr.answers.reduce((pAnswer, cAnswer) => pAnswer + cAnswer.score || 0, 0)),
            }
        ), { score: 0, max: 0 });

        return (
            <div className={classes.root}>
                {questionsWithAnswers.map(q => (
                    <FormQuestion
                        key={q.id}
                        question={q}
                        response={taskResponses[q.id]?.response}
                        contentState={contentState}
                        elementSettings={elementSettings}
                        showScores
                        handleResponseUpdate={() => {}}
                    />
                ))}

                <div className={classes.results}>
                    <Typography variant="subtitle1" className={classes.scoreHeading} id={`${contentElemenIdPrefix}${element.id}_quizScore`}>
                        {translate('taskContent.youGotxOfXScore', scoring)}
                    </Typography>

                    <Button onClick={this.resetQuiz} className={classes.resetButton} variant="contained" color="primary">
                        {translate('taskContent.retakeQuiz')}
                    </Button>
                </div>

            </div>
        );
    }
}


QuizResponse.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    element: PropTypes.object.isRequired,
    taskId: PropTypes.string.isRequired,
    getProgramItem: PropTypes.func.isRequired,
    getSpecificTaskResponses: PropTypes.func.isRequired,
    handleResponseUpdate: PropTypes.func.isRequired,
    contentState: PropTypes.string,
};

QuizResponse.defaultProps = {
    contentState: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
});

export default connect(mapStateToProps)(withStyles(styles)(QuizResponse));
